export function formatDate(date: string): string {
  const yourDate = new Date(date);
  const year = yourDate.getFullYear();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = monthNames[yourDate.getMonth()];
  const day = yourDate.getDate();

  return `${month}, ${day.toString().padStart(2, "0")} ${year}`;
}

export function Hour12Format(timeString: string): string {
  // console.log(timeString);
  const date = new Date(timeString);
  // console.log(date);
  const hours = date.getHours() - 6;
  const minutes = date.getMinutes() - 30;
  // console.log(hours, minutes);
  const amPm = hours >= 12 ? "PM" : "AM";
  const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${formattedHours}:${formattedMinutes} ${amPm}`;
}

export function transform(value: string): string {
  return value
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
